// 1. Definisci un tipo flessibile per gli eventi della dataLayer
//    La proprietà 'event' è una stringa generica.
//    [key: string]: any permette di aggiungere qualsiasi altra proprietà (es. page_path, value, etc.)
type GtmEvent = {
  event: string;
  [key: string]: unknown;
};

// 2. Estendi l'interfaccia globale di Window per includere 'dataLayer' con il tipo corretto.
//    Questo darà a TypeScript l'autocompletamento e il controllo dei tipi in tutto il progetto.
declare global {
  interface Window {
    dataLayer: GtmEvent[];
  }
}

// 3. Crea una funzione "helper" per inviare gli eventi.
//    Questo garantisce che la dataLayer sia sempre un array prima di fare il push.
export const sendGtmEvent = (data: GtmEvent) => {
  // Controlla che window sia definito (evita errori durante il Server-Side Rendering)
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};
